module.exports = __webpack_public_path__ + "img/wm.08484b75.png";